// import { baim } from '@b2x/baim';
import { b2x } from '@b2x/react/src';
import React from 'react';

import { BannerSliderFromDirectory } from '../BannerSliderFromDirectory';
import { CollectionA } from '../CollectionA';
import { HomePageContentType } from '../contentTypes';
import { CopyA } from '../CopyA';
import { MultiColumnA } from '../MultiColumnA';
import { usePopupNewsletterModal } from '../PopupNewsletterModal';
import { ProductListA } from '../ProductListA';
import { SliderA } from '../SliderA';
import { SocialFeedA } from '../SocialFeedA';
import { FooterNewsletter } from './FooterNewsletter';
import { Page } from './Page';

export interface HomePageProps {}

export const HomePage = (props: HomePageProps) => {
  const page = b2x.usePage<HomePageContentType>({
    secondStep: {
      populate: {
        products: b2x.appConfig.api?.productTilePopulate,
      },
    },
  });
  const { pageReady } = b2x.useAppContext();
  const [PopupNewsLetterModal, showPopupNewsLetterModal] = usePopupNewsletterModal({
    onClose: () => {
      const modalClosedTimes = (b2x.storage.getNumber('homePageNewsletterModalClosedTimes', true) ?? 0) + 1;
      b2x.storage.setNumber('homePageNewsletterModalClosedTimes', modalClosedTimes, true);
    },
  });

  React.useEffect(() => {
    const newsletterConsent = b2x.storage.getBoolean('newsletterConsent', true);
    if (newsletterConsent) {
      return;
    }

    const modalClosedTimes = b2x.storage.getNumber('homePageNewsletterModalClosedTimes', true) ?? 0;
    if (modalClosedTimes < 2 && pageReady) {
      b2x.wait(3000 * (modalClosedTimes + 1)).then(showPopupNewsLetterModal);
    }
  }, [pageReady, showPopupNewsLetterModal]);

  return (
    <Page noPaddingBottom noPaddingTop>
      {page?.content?.body.showPopupSection?.showPopup && PopupNewsLetterModal}
      {page?.content?.body.bannerSliderFromDirectory?.options?.enabled &&
      page.content.body.bannerSliderFromDirectory.directoryCode ? (
        <BannerSliderFromDirectory
          directoryCode={page.content.body.bannerSliderFromDirectory.directoryCode}
          options={page.content.body.bannerSliderFromDirectory.options}
        />
      ) : (
        page?.content?.body.sliderA?.options?.enabled && <SliderA {...page.content.body.sliderA} />
      )}
      {page?.content?.body.copyA?.options?.enabled && <CopyA {...page.content.body.copyA} />}
      {page?.content?.body.productListA?.options?.enabled && <ProductListA {...page.content.body.productListA} />}
      {page?.content?.body.collectionA?.options?.enabled && <CollectionA {...page.content.body.collectionA} />}
      {page?.content?.body.multiColumnA?.options?.enabled && <MultiColumnA {...page.content.body.multiColumnA} />}
      {page?.content?.body.socialFeedA?.options?.enabled && <SocialFeedA {...page.content.body.socialFeedA} />}
      <b2x.Div className="bg-gray-100 box-newsletter py-5">
        <FooterNewsletter />
      </b2x.Div>
    </Page>
  );
};
